var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-popover',{attrs:{"placement":_vm.placement,"title":_vm.title,"width":_vm.width,"trigger":_vm.trigger,"value":_vm.value,"popper-class":_vm.popperClassCom,"content":_vm.content},on:{"input":_vm.onInput}},[_vm._t("default"),_vm._v(" "),_vm._t("reference",null,{"slot":"reference"})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-0c27fa66","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./UI/Popover/index.vue
// module id = 719
// module chunks = 0